export const WebToNativeMessage = (message) => {
    // window.ReactNativeWebView.postMessage(message)
    let style = ` 
    color:white; 
    font-size:0.75rem; 
    background-color:#2C5391; 
    padding: 0.5rem;
    ` 
    let date = new Date();

    let data = JSON.stringify(message);
    
    let userAgent = window.navigator.userAgent.toLocaleLowerCase();
    if (userAgent.indexOf("android") === -1) {
        if (window.webkit !== undefined) {
            window.webkit.messageHandlers.RedirectTo.postMessage(data);
            // console.log(`Web to Native >>> ${data}`)
            console.log(`%cMessage to Native Application RedirectTo ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>>`, style, data);
        }
    } else {
        if (userAgent.toString().includes("wv")) {
            if (window.android !== undefined) {
                window.android.redirectTo(data);
                // console.log(`Web to Native >>> ${data}`)
                console.log(`%cMessage to Native Application redirectTo ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()} >>>`, style, data);
            }
        }
    }
}

export const apiLogResponseStyle = `color:#FFFFFF; font-size:0.75rem; background-color:#34A853; font-weight:700; padding-top: 0.5rem; padding-bottom: 0.5rem;`;

/* Missions Bonus Types */

export const GV_BONUS_TYPE = 'gv'
export const PLAY_PASS_BONUS_TYPE = 'playpass'
export const PD_BONUS_TYPE = 'pd'
export const RUPEE_SYMBOL = '\u20B9'


export const debugLogStyle = `color:#FFFFFF; font-size:0.75rem; background-color:#767676; font-weight:700; padding-top: 0.5rem; padding-bottom: 0.5rem;`;


export function convertToWords(number, challenge) {
    //   console.log("Num in convert => ", Math.round(Number(number)));
      if (number === undefined || number === '' || number === null || number < 0) return ''
    try {
        const numberString = number?.toString();
      if (number >= 10000000) {
          const croreIndex = numberString?.length - 7;
          let amtText = numberString?.slice(0, croreIndex);
            return `${amtText} ${numberString.slice(amtText.length, amtText.length + 1) !== '00' ? '.' + numberString.slice(amtText.length, amtText.length + 1) : ''} Cr`;
        
          //   const num = toConvert / 10000000
        //   return `${Math.round(num)} Cr`
      } else if (number >= 100000) {
          const croreIndex = numberString?.length - 5;
          let amtText = numberString?.slice(0, croreIndex);
            // return amtText + '.' + numberString.slice(amtText.length, amtText.length + 2) + ' Lac';
          return `${amtText}${numberString?.slice(amtText.length, amtText.length + 1) !== '00' ? '.' + numberString?.slice(amtText.length, amtText.length + 1) : ''} Lac`;

        //   const num = toConvert / 100000
        //   return `${Math.round(num)} Lac`
      } else {
          const formattedNumber = Number(number)?.toLocaleString();
        
        // Check for "realstake" challenge and add .0 for integers
          if (challenge === 'realstake' && Number?.isInteger(number)) {
          return `${formattedNumber}.0`;
        }
  
        return formattedNumber;
      }
    } catch (error) {
      console.log("error while converting number to words", error);
    }
  }
export function createAdminPageURL(baseURL, condition) {
  return condition ? `${baseURL}&channel=oemaps1` : baseURL;
}

export function createOEMAdminPageURL(baseURL, oemBaseURL, endPoint, condition) {
  // let returnUrl;
  if(condition){
    console.log("oemBaseURL Data>>>",baseURL,endPoint)
    return `${oemBaseURL}${endPoint}`
    // returnUrl = oemBaseURL + endPoint + "&channel=oemaps1"
  }
  else{
    // returnUrl = baseURL + endPoint
    console.log("baseURL Data>>>",baseURL,endPoint)
    return `${baseURL}${endPoint}`
  }
  // return condition ? `${baseURL}&channel=oemaps1` : baseURL;
  // return returnUrl
}


